// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fy77g","toggleWrap":"styles_toggleWrap__1kW0g","content":"styles_content__1IDlR","selectAreaCode":"styles_selectAreaCode__2vTp_"};